import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import { memo } from "react";
import { useSelector } from "react-redux";
import { SectionDisplay } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/SectionDisplay";
import { centralizedClipCreatedDateSelector, centralizedClipOwnerSelector, centralizedClipRecordedAtSelector, centralizedClipUpdatedAtSelector } from "~/store/centralizedClip/selectors";
export const FileInfo = /*#__PURE__*/ memo(()=>{
    const recordedAt = useSelector(centralizedClipRecordedAtSelector);
    const formattedCreatedAt = format(parseAirDateToISO(recordedAt), MONTH_DAY_YEAR_FORMAT);
    const updatedAt = useSelector(centralizedClipUpdatedAtSelector);
    const formattedUpdatedAt = format(parseAirDateToISO(updatedAt), MONTH_DAY_YEAR_FORMAT);
    const uploadedAt = useSelector(centralizedClipCreatedDateSelector);
    const formattedUploadedAt = format(parseAirDateToISO(uploadedAt), MONTH_DAY_YEAR_FORMAT);
    const owner = useSelector(centralizedClipOwnerSelector);
    return /*#__PURE__*/ _jsxs(SectionDisplay, {
        title: "File Info",
        children: [
            !!formattedCreatedAt && /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-9",
                        children: "Date Created"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-11",
                        children: formattedCreatedAt
                    })
                ]
            }),
            !!formattedUpdatedAt && /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-9",
                        children: "Modified"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-11",
                        children: formattedUpdatedAt
                    })
                ]
            }),
            !!formattedUploadedAt && /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-9",
                        children: "Uploaded"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-11",
                        children: formattedUploadedAt
                    })
                ]
            }),
            !!owner && /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-9",
                        children: "Uploaded by"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 text-grey-11",
                        children: owner.ownerName
                    })
                ]
            })
        ]
    });
});
FileInfo.displayName = "FileInfo";
